<div class="topbar-item d-none d-sm-flex">
  <button (click)="layout.openCustomizer()" class="topbar-link" type="button">
    <lucide-icon [img]="Settings" class="fs-xxl"/>
  </button>
</div>
